import React from 'react';
import cn from 'classnames';
import Slider from 'components/Slider';
import LocationCard from './LocationCard';
import { useInView } from 'react-intersection-observer';

import * as styles from './MobileContent.module.scss';

export default function MobileContent({ items }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });

  const sliderSettings = {
    desktopSlidesToShow: 2,
    desktopSlidesToScroll: 2,
    tabletSlidesToShow: 2,
    tabletSlidesToScroll: 2,
  };

  return (
    <div className={cn(styles.sliderWrapper, 'defaultSlider')} ref={inViewRef}>
      {inView && (
        <Slider slides={items} {...sliderSettings}>
          {items.map((slide, i) => (
            <div key={i} className={styles.slide}>
              <LocationCard {...slide} />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}
